<template>
  <div class="login_index">
    <div class="index_content">
      <div class="zhanwei"></div>
      <img src="@assets/images/new/logo.png" class="logoImg" />
      <div class="login">
        <div class="div_input">
          <span>手机号:</span>
          <input
            type="text"
            placeholder="请输入手机号"
            v-model="account"
            maxlength="11"
          />
        </div>
        <div class="div_input">
          <span>密码:</span>
          <input
            type="password"
            placeholder="请输入密码"
            v-model="password"
            maxlength="15"
          />
        </div>
        <div class="div_p">
          <router-link :to="'/user/hc_forgetpassword'" class="btna">
            <span>忘记密码?</span>
          </router-link>
          <router-link :to="'/user/hc_zhuce'" class="btna">
            <span>新用户注册?</span>
          </router-link>
        </div>
        <button @click="loginbtn" class="loginbtn">登录</button>
      </div>
    </div>
  </div>
</template>

<script>
import { hcLogin } from "@api/user";
import cookie from "@utils/store/cookie";
export default {
  name: "index",
  mixins: [],
  data: function() {
    return {
      account: "", //手机号
      password: "" //密码
    };
  },
  mounted: function() {
    this.init();
  },
  methods: {
    init() {
      let that = this;
      that.account = cookie.get("phone_login") ? cookie.get("phone_login") : "";
      that.password = cookie.get("password_login")
        ? cookie.get("password_login")
        : "";
      console.log("expires_time:", cookie.get("expires_time"));
      console.log("token:", cookie.get("token"));
      if (that.account && that.password) {
        that.loginbtn();
      }
    },
    loginbtn() {
      var that = this;
      console.log("account：", that.account);
      console.log("password：", that.password);
      if (!/1[3-9]\d{9}/.test(that.account)) {
        that.$dialog.message("请正确输入11位手机号");
        return;
      } else if (that.password.length < 6 || that.password.length > 15) {
        that.$dialog.message("密码有误，请仔细检查！");
        return;
      } else {
        hcLogin({ account: that.account, password: that.password })
          .then(res => {
            console.log("登录返回：", res);
            if (res.status == 400) {
              that.$dialog.error(res.msg);
            } else {
              const datas = {
                token: res.data.token,
                expires_time: res.data.expires_time
              };
              console.log("datas：", datas);
              cookie.set("token", res.data.token);
              cookie.set("expires_time", res.data.expires_time);
              cookie.set("phone_login", that.account);
              cookie.set("password_login", that.password);
              that.$store.commit("LOGIN", datas);

              console.log("返回正常");
              window.location.href = "/user/hc_main";
            }
          })
          .catch(e => {
            console.log("返回错误：", e);
            that.$dialog.error(e.msg);
          });
      }
    }
  }
};
</script>

<style>
#footer {
  display: none;
}
#right-nav {
  display: none;
}
.login_index {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #fff;
}
.index_content {
  width: calc(100% - 1.3rem);
  margin: 0 auto;
}
.zhanwei {
  width: 100%;
  height: 1.28rem;
}
.logoImg {
  display: block;
  width: 2.38rem;
  height: 2.2rem;
  position: relative;
  margin: 0 auto;
}
.login {
  width: 100%;
  height: auto;
  margin: 0.73rem auto;
}
.div_input {
  width: 100%;
  height: 0.97rem;
  margin-top: 0.38rem;
  background-color: #f3f4f8;
  display: flex;
  border-radius: 0.5rem;
}
.div_input span {
  padding-left: 0.31rem;
  display: block;
  height: 0.97rem;
  line-height: 0.97rem;
  color: #666666;
  font-size: 0.28rem;
  width: 1.8rem;
}
.div_input input {
  display: block;
  height: 0.97rem;
  color: #333;
  font-size: 0.28rem;
  width: calc(100% - 1.8rem - 0.31rem);
}
.div_input input::-webkit-input-placeholder {
  color: #a1a9b4;
  font-size: 0.28rem;
}
.div_p {
  width: 94%;
  margin: 0.3rem auto 0;
  display: flex;
  justify-content: space-between;
}
.div_p .btna {
  color: #275caa;
  font-size: 0.26rem;
}
.loginbtn {
  display: block;
  width: 100%;
  color: #fff;
  height: 0.97rem;
  line-height: 0.97rem;
  background-color: #275caa;
  border-radius: 0.5rem;
  font-size: 0.32rem;
  margin-top: 0.78rem;
}
</style>
